export default __webpack_public_path__ + "static/media/il_proceso_ins.ba57719a.svg";